module.exports = __webpack_public_path__ + "img/goldkette.53875d35.png";